import React from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { Translate as TranslateIcon } from "@mui/icons-material";
import { useQueryClient } from "react-query";
import { styled } from "@mui/material/styles";

import { i18n } from "src/i18n";
import { useLanguages } from "src/hooks/useLanguages";

export function LanguageMenu() {
  const queryClient = useQueryClient();
  const { data: languages } = useLanguages();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  /**
   * Functions
   */
  function handleMenu(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }
  function handleSetLanguage(key: string) {
    setAnchorEl(null);
    i18n.changeLanguage(key);
    queryClient.clear();
    window.location.reload();
  }

  // render the component
  return render();

  function render() {
    if (!languages) return null;

    const activeLanguage = languages.find((language) => i18n.language.includes(language.key));

    return (
      <Styles>
        <Button aria-haspopup="true" onClick={handleMenu} startIcon={<TranslateIcon />} color="inherit">
          {activeLanguage?.translation}
        </Button>
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          keepMounted
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          open={open}
          onClose={handleClose}
        >
          {languages.map((language) => (
            <MenuItem
              key={language.key}
              onClick={() => {
                handleSetLanguage(language.key);
              }}
              selected={i18n.language === language.key}
            >
              {language.translation}
            </MenuItem>
          ))}
        </Menu>
      </Styles>
    );
  }
}

const Styles = styled("div")`
  * {
    text-transform: capitalize;
  }
`;
